import React from 'react';
import styles from '../styles/Countdown.module.css';

/**
 * Componente de cuenta regresiva
 * @param {Object} countdown - { days, hours, minutes, seconds, isExpired }
 * @param {string} label - Texto superior (ej: "FALTAN")
 * @param {string} className - Clases CSS adicionales
 */
const Countdown = ({ countdown, label = 'FALTAN', className = '' }) => {
  const { days, hours, minutes, seconds, isExpired } = countdown;

  if (isExpired) {
    return (
      <div className={`${styles.countdownSection} ${className}`}>
        <span className={styles.expiredLabel}>¡Ya está disponible!</span>
      </div>
    );
  }

  const formatValue = (value) => String(value).padStart(2, '0');

  return (
    <div className={`${styles.countdownSection} ${className}`}>
      <span className={styles.countdownLabel}>{label}</span>
      <div className={styles.countdownTimer}>
        <div className={styles.countdownItem}>
          <span className={styles.countdownValue}>{formatValue(days)}</span>
          <span className={styles.countdownUnit}>DÍAS</span>
        </div>
        <span className={styles.countdownSeparator}>:</span>
        <div className={styles.countdownItem}>
          <span className={styles.countdownValue}>{formatValue(hours)}</span>
          <span className={styles.countdownUnit}>HORAS</span>
        </div>
        <span className={styles.countdownSeparator}>:</span>
        <div className={styles.countdownItem}>
          <span className={styles.countdownValue}>{formatValue(minutes)}</span>
          <span className={styles.countdownUnit}>MINUTOS</span>
        </div>
        <span className={styles.countdownSeparator}>:</span>
        <div className={styles.countdownItem}>
          <span className={styles.countdownValue}>{formatValue(seconds)}</span>
          <span className={styles.countdownUnit}>SEGUNDOS</span>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
